var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const windowHelper = window;
const reviewPageElement = document.getElementById("review-page");
const $ = window.$;
const referralFreeGiftVariantId = 32482822029372;
export function addReferralFreeGift() {
    return __awaiter(this, void 0, void 0, function* () {
        const cart = yield windowHelper.$.getJSON('/cart.js');
        console.log('cart', cart);
        if (cart.items.some(x => x.variant_id == referralFreeGiftVariantId))
            return false;
        yield windowHelper.$.post('/cart/add.js', {
            items: [
                {
                    quantity: 1,
                    id: referralFreeGiftVariantId
                }
            ]
        });
        return true;
    });
}
